import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import RadioButton from 'components/radio_button/radio_button'
import Checkbox from 'components/checkbox/checkbox'
import { TextInput } from 'components/dpc_input'
import VideoSettingsSupportSection from './components/video_settings_support_section'

import styles from './video_settings_modal.scss'

import closeIcon from 'assets/global/global_close.svg'
import settingsIcon from 'assets/views/interactive_video/settings-header-icon.png'

class VideoSettingsModal extends PureComponent {

	constructor(props) {
		super(props)

		const grades = {}
		props.grades.forEach(grade => {
			grades[grade.id] = props.gradeIds.includes(grade.id)
		})
		this.state = {
			isOptionsBoxOpen: false,
			subjectSelected: props.subjectId,
			gradesSelected: grades,
			title: {
				value: props.videoTitle.value,
				touched: true,
			},
		}
	}

	toggle = () => {
		this.setState({
			isOptionsBoxOpen: true,
		})
	}

	isIncluded = id => this.state.gradesSelected[id]

	setSubject = event => {
		this.setState({
			subjectSelected: event.target.value,
		})
	}

	setGradesSelected = id => {
		this.setState({
			gradesSelected: {
				...this.state.gradesSelected,
				[id]: !this.state.gradesSelected[id],
			},
		})
	}

	setTitle = event => {
		this.setState({
			title: {
				...this.state.title,
				value: event.target.value,
				touched: true,
			},
		})
	}

	getSelectedGrades = () =>
		Object.keys(this.state.gradesSelected)
			.filter(key => this.state.gradesSelected[key])

	submitVideoSettings = () => {
		this.setState({
			title: {
				...this.state.title,
				touched: false,
			},
		})

		const grades = this.getSelectedGrades()

		const settings = {
			subjectSelected: this.state.subjectSelected,
			gradesSelected: grades,
			title: this.state.title.value,
		}
		this.props.submitHandler(settings)
	}



	buildSubjectsListItems = subject => (
		<li styleName='options-box-column-list-item' key={subject.id}>
			<RadioButton
				name='subjectId'
				value={subject.id}
				id={`subject_${subject.id}`}
				onChange={this.setSubject}
				checked={this.state.subjectSelected === subject.id}
			/>
			<label
				styleName='options-box-column-list-item-label'
				htmlFor={`subject_${subject.id}`}
			>
				{subject.value}
			</label>
		</li>
	)

	buildGradesListItems = grade => (
		<li styleName='options-box-column-list-item' key={grade.id}>
			<Checkbox
				name={`grade_${grade.id}`}
				value={this.isIncluded(grade.id)}
				id={`grade_${grade.id}`}
				onChange={() => this.setGradesSelected(grade.id)}
			/>
			<label
				styleName='options-box-column-list-item-label'
				htmlFor={`grade_${grade.id}`}
			>
				{grade.value}
			</label>
		</li>
	)

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='veil' onClick={this.props.closeModalHandler}></div>
				<main styleName='container'>
					<form
						id='interactiveVideoSettings'
						onSubmit={event => {
							event.preventDefault()
							this.submitVideoSettings()
						}}
					>
						<div styleName='close-button' onClick={this.props.closeModalHandler}>
							<img src={closeIcon} />
						</div>
						<div styleName='header'>
							<div styleName='header-icon'>
								<img src={settingsIcon} alt={localize('interactive_video_details')} />
							</div>
							<h2 styleName='header-title'>
								{localize('interactive_video_settingsModal_title')}
							</h2>
						</div>
						<TextInput
							placeholder= {localize('interactive_video_settingsModal_inputPlaceholder')}
							onChange={this.setTitle}
							value={this.state.title.value}
							status={!!this.props.videoTitle.error && !this.state.title.touched ? 'error' : ''}
							message={this.props.videoTitle.error}
							autoSelect={this.props.shouldAutoselectTitle}
						/>
						<div styleName='options'>
							<span styleName='options-toggle'>
								<TextLink onClick={this.toggle}>
									{localize('interactive_video_settingsModal_toggle')}
								</TextLink>
							</span>
							<div styleName={classNames({
								'options-box': true,
								'options-box--open': this.state.isOptionsBoxOpen,
							})}>
								<div styleName='options-box-column'>
									<ul styleName='options-box-column-list'>
										{this.props.subjects.map(
											this.buildSubjectsListItems)
										}
									</ul>
								</div>
								<div styleName='options-box-column'>
									<ul styleName='options-box-column-list'>
										{this.props.grades.map(
											this.buildGradesListItems)
										}
									</ul>
								</div>
							</div>
						</div>
						<div styleName='footer'>
							<div styleName='footer-button'>
								<MainButton
									type='submit'
								>
									{localize('interactive_video_settingsModal_submit')}
								</MainButton>
							</div>
						</div>
					</form>
					{ this.props.canEditSupportSettings &&
						<div styleName='support'>
							<VideoSettingsSupportSection
								onPosterPicked={this.props.onPosterPicked}
								onPosterError={this.props.onPosterError}
								onTranscriptPicked={this.props.onTranscriptPicked}
								onTranscriptError={this.props.onTranscriptError}
								onQuestionPicked={this.props.onQuestionPicked}
								onQuestionError={this.props.onQuestionError}
								onSaveCredits={this.props.onSaveCredits}
								credits={this.props.credits}
							/>
						</div>
					}
				</main>
			</div>
		)
	}
}

VideoSettingsModal.propTypes = {
	shouldAutoselectTitle: PropTypes.bool,
	closeModalHandler: PropTypes.func,
	subjects: PropTypes.array,
	grades: PropTypes.array,
	submitHandler: PropTypes.func,
	gradeIds: PropTypes.array,
	subjectId: PropTypes.number,
	videoTitle: PropTypes.shape({
		value: PropTypes.string,
		error: PropTypes.string,
	}),
	credits: PropTypes.string.isRequired,
	canEditSupportSettings: PropTypes.bool,
	onPosterPicked: PropTypes.func,
	onPosterError: PropTypes.func,
	onTranscriptPicked: PropTypes.func,
	onTranscriptError: PropTypes.func,
	onQuestionPicked: PropTypes.func,
	onQuestionError: PropTypes.func,
	onSaveCredits: PropTypes.func,
}

VideoSettingsModal.defaultProps = {
	shouldAutoselectTitle: false,
	closeModalHandler: () => {},
	subjects: [],
	grades: [],
	submitHandler: () => {},
	gradeIds: [],
	subjectId: 0,
	videoTitle: {
		value: '',
		error: '',
	},
	canEditSupportSettings: false,
	onPosterPicked: () => {},
	onPosterError: () => {},
	onTranscriptPicked: () => {},
	onTranscriptError: () => {},
	onQuestionPicked: () => {},
	onQuestionError: () => {},
	onSaveCredits: () => {},
}

export default CSSModules(VideoSettingsModal, styles, {allowMultiple: true})
